const ByteTcmbExchange = {
  async fetchUsdRate(apiEndpoint) {
    const apiUrl = String(apiEndpoint || '').trim();

    if (!apiUrl) {
      throw new Error('TCMB API endpoint is missing');
    }

    const response = await fetch(apiUrl, { cache: 'no-store' });

    if (!response.ok) {
      throw new Error(`TCMB API request failed: ${response.status}`);
    }

    const data = await response.json();

    if (data.status !== 'success') {
      throw new Error('TCMB API returned error status');
    }

    const rate = Number(String(data.rate).replace(',', '.'));

    if (!Number.isFinite(rate) || rate <= 0) {
      throw new Error('Invalid USD rate from API');
    }

    let dateText = new Date().toLocaleDateString('tr-TR');

    if (data.updated_at) {
      const updatedDate = new Date(data.updated_at);
      if (!Number.isNaN(updatedDate.getTime())) {
        dateText = updatedDate.toLocaleString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      }
    }

    return {
      rate,
      date: dateText,
      source: data.source || 'TCMB',
      currency: data.currency || 'USD',
    };
  },
};
